import { motion } from "framer-motion";
import ConsultationBooking from "../components/features/ConsultationBooking";

export default function ConsultationPage() {
  return (
    <div className="bg-gray-50 pt-24">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-center mb-12"
        >
          <h1 className="text-4xl font-serif font-bold text-primary-900 mb-4">
            Virtual Hair Consultation
          </h1>
          <p className="text-lg text-gray-600">
            Book a one-on-one consultation with our hair care experts to discuss
            your hair concerns and get personalized advice.
          </p>
        </motion.div>

        <ConsultationBooking />
      </div>
    </div>
  );
} 